import { Component } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-unauth',
  standalone: true,
  imports: [TranslocoModule],
  template: `
    <div class="h-screen flex flex-col items-center justify-center bg-gray-100 text-center p-4">
      <div class="text-xl text-red-600 font-semibold">{{ 'auth.unauthorizedMessage' | transloco }}</div>
      <a href="/auth" class="mt-4 text-blue-500 hover:underline">{{ 'auth.loginButton' | transloco }}</a>
    </div>
  `
})
export class UnauthComponent {}
